<script setup lang="ts">
import { ref, type Component } from 'vue';
import MobileNav from './components/MobileNav.vue';
import TheFooter from './components/TheFooter.vue';
import TheHeader from './components/TheHeader.vue';

defineProps<{
  /** Компонент-страница (HomeView / AboutView / RequirementsView), рендерится в <main> */
  view: Component;
  /** Ключ текущей страницы для подсветки активного пункта меню */
  current: string;
}>();

const mobileMenuOpen = ref(false);
</script>

<template>
  <a href="#main" class="sr-only">Перейти к содержимому</a>

  <TheHeader :current="current" @open-menu="mobileMenuOpen = true" />
  <MobileNav :open="mobileMenuOpen" :current="current" @close="mobileMenuOpen = false" />

  <main id="main">
    <component :is="view" />
  </main>

  <TheFooter />
</template>
